export const translations = {
  es: {
    nav: {
      home: "Inicio",
      treatments: "Tratamientos",
      clinic: "Clínica",
      promotions: "Promociones",
      blog: "Blog",
      jobs: "Trabaja con nosotros",
      contact: "Contacto",
      cta: "Pedir Cita",
      view_all: "Ver todos los tratamientos",
    },
    hero: {
      eyebrow: "Odontología Boutique · Cerdanyola del Vallès",
      title_1: "Eleva tu",
      title_2: "sonrisa,",
      title_3: "sin esfuerzo.",
      lede:
        "Una clínica donde la precisión clínica y el diseño se encuentran. Tratamientos personalizados, tecnología de vanguardia y un trato profundamente humano.",
      cta_primary: "Primera visita gratuita",
      cta_secondary: "Explorar tratamientos",
      tag_left: "Primera visita + diagnóstico",
      tag_left_strong: "GRATIS",
      scroll: "Desliza",
    },
    philosophy: {
      eyebrow: "Filosofía",
      quote:
        "La salud bucodental de nuestros pacientes es nuestro mayor logro. Cada sonrisa es un proyecto único — concebido con técnica, paciencia y belleza.",
      sign: "— Dr. Iñaki Mayo",
      body:
        "Combinamos ortodoncia digital, implantología avanzada y diseño de sonrisa en un entorno sereno, pensado para que vuelvas a disfrutar sin esfuerzo.",
    },
    stats: {
      a_num: "+20",
      a_label: "Años de experiencia",
      b_num: "+8.000",
      b_label: "Pacientes atendidos",
      c_num: "+2.500",
      c_label: "Casos de Invisalign",
      d_num: "100%",
      d_label: "Planes personalizados",
    },
    treatments: {
      eyebrow: "Tratamientos destacados",
      title: "Una atención que se adapta a ti.",
      cta_all: "Ver todos los tratamientos",
      learn_more: "Saber más",
      benefits: "Beneficios",
      duration: "Duración estimada",
      sessions: "Visitas estimadas",
      cta_book: "Reservar consulta",
      cta_info: "Más información",
    },
    doctor: {
      eyebrow: "Dirección clínica",
      name: "Dr. Iñaki Mayo",
      title: "Vuelve a sonreír cada día, vuelve a ser tú.",
      bio_1:
        "Especialista en implantología y rehabilitación oral con más de dos décadas de práctica clínica. Combina formación internacional con un enfoque artístico de la odontología.",
      bio_2:
        "Su filosofía: tratar a cada paciente como una pieza única, con tiempo, precisión y honestidad.",
      sign: "Iñaki Mayo",
      cta_team: "Conoce al equipo",
    },
    testimonials: {
      eyebrow: "Testimonios",
      title: "La experiencia de quienes ya sonríen con nosotros.",
      items: [
        { quote: "Han devuelto a mi sonrisa lo que yo creía perdido. El trato y la profesionalidad son excepcionales.", name: "Marta R.", city: "Cerdanyola" },
        { quote: "Después de mi Invisalign no reconozco la persona que era antes. La atención de todo el equipo es exquisita.", name: "Joan S.", city: "Sabadell" },
        { quote: "Un espacio que no parece una clínica. Te cuidan como si fueras parte de una familia.", name: "Laura P.", city: "Ripollet" },
      ],
    },
    faq: {
      eyebrow: "Preguntas frecuentes",
      title: "Todo lo que necesitas saber.",
      items: [
        { q: "¿Cuánto cuesta la primera visita?", a: "La primera visita y el diagnóstico son completamente gratuitos. Incluye exploración, las radiografías necesarias y un plan de tratamiento personalizado por escrito." },
        { q: "¿Trabajan con financiación?", a: "Sí. Disponemos de financiación a medida, sin intereses hasta 12 meses y opciones flexibles hasta 60 meses." },
        { q: "¿Atienden a niños?", a: "Disponemos de un programa exclusivo Mayo Kids con odontopediatras especializados y un entorno pensado para los más pequeños." },
        { q: "¿Cuánto dura el tratamiento de Invisalign?", a: "Depende de la complejidad. Los tratamientos suelen oscilar entre 6 y 18 meses, con revisiones cada 6–8 semanas." },
        { q: "¿Cómo solicito cita?", a: "Puedes contactarnos por WhatsApp al 621 078 618, por teléfono al 934 090 407 o desde el formulario de contacto. Respondemos en menos de 24 horas laborables." },
      ],
    },
    contact: {
      eyebrow: "Contacto",
      title: "Hablemos de tu sonrisa.",
      lede: "Estamos a un mensaje de distancia. Resolvemos tus dudas, valoramos tu caso y te proponemos un plan a tu medida.",
      whatsapp: "Escríbenos por WhatsApp",
      call: "Llamar a la clínica",
      address_label: "Dirección",
      address: "Av. Catalunya, 24\n08290 Cerdanyola del Vallès\nBarcelona",
      hours_label: "Horario",
      hours: "Lun–Vie: 9:00 – 20:30\nSábado: 10:00 – 14:00",
      email_label: "Email",
      form_title: "Envíanos un mensaje",
      f_name: "Nombre y apellidos",
      f_phone: "Teléfono",
      f_email: "Email",
      f_message: "Cuéntanos brevemente tu caso",
      f_treatment: "Tratamiento de interés (opcional)",
      f_consent: "He leído y acepto la política de privacidad",
      f_submit: "Enviar mensaje",
      f_success: "Mensaje enviado. Te contactaremos en menos de 24h.",
      f_error: "No hemos podido enviar tu mensaje. Inténtalo de nuevo.",
      f_required: "Por favor, completa los campos obligatorios.",
    },
    treatments_page: {
      eyebrow: "Catálogo de tratamientos",
      title: "Tratamientos de vanguardia,\ndiseñados para ti.",
      lede: "Una odontología que une tecnología avanzada con una visión artesanal del detalle.",
      jump: "Ir al tratamiento",
    },
    promotions_page: {
      eyebrow: "Promociones",
      title: "Cuidamos también de tu bolsillo.",
      lede:
        "Selección de promociones activas. Sujetas a disponibilidad y a estudio personalizado previo.",
      terms: "Promociones no acumulables entre sí. Sujetas a estudio previo y disponibilidad de agenda.",
    },
    blog_page: {
      eyebrow: "Mayo Magazine",
      title: "Conversaciones sobre tu sonrisa.",
      lede: "Artículos breves del equipo clínico — para entender mejor cada tratamiento.",
      read_more: "Leer artículo",
    },
    jobs_page: {
      eyebrow: "Trabaja con nosotros",
      title: "Buscamos profesionales\ncon vocación.",
      lede:
        "Si quieres unirte a un equipo que entiende la odontología como una profesión artística y humana, este es tu sitio. Envíanos tu candidatura.",
      f_position: "Puesto de interés",
      f_experience: "Años de experiencia",
      f_message: "Carta de presentación",
      f_submit: "Enviar candidatura",
      f_success: "Candidatura recibida. Te contactaremos pronto.",
      values_title: "Lo que nos mueve",
      values: [
        { t: "Excelencia clínica", d: "Formación continua y protocolos al máximo nivel internacional." },
        { t: "Trato humano", d: "Cada paciente es una persona, no un caso clínico." },
        { t: "Tecnología", d: "Trabajamos con los mejores equipos digitales del sector." },
        { t: "Equipo", d: "Crecemos juntos. La clínica es lo que su equipo construye cada día." },
      ],
    },
    footer: {
      tag: "Primera visita + diagnóstico GRATIS",
      cta: "Pide tu cita",
      legal: "Aviso legal",
      privacy: "Política de privacidad",
      cookies: "Política de cookies",
      rights: "© 2026 Iñaki Mayo Dental. Todos los derechos reservados.",
      made: "Odontología boutique en Cerdanyola del Vallès.",
      sections: {
        clinic: "Clínica",
        treatments: "Tratamientos",
        contact: "Contacto",
        explore: "Explora",
      },
      follow: "Síguenos",
    },
  },

  ca: {
    nav: {
      home: "Inici",
      treatments: "Tractaments",
      clinic: "Clínica",
      promotions: "Promocions",
      blog: "Blog",
      jobs: "Treballa amb nosaltres",
      contact: "Contacte",
      cta: "Demanar cita",
      view_all: "Veure tots els tractaments",
    },
    hero: {
      eyebrow: "Odontologia Boutique · Cerdanyola del Vallès",
      title_1: "Eleva el teu",
      title_2: "somriure,",
      title_3: "sense esforç.",
      lede:
        "Una clínica on la precisió clínica i el disseny es troben. Tractaments personalitzats, tecnologia d'avantguarda i un tracte profundament humà.",
      cta_primary: "Primera visita gratuïta",
      cta_secondary: "Explorar tractaments",
      tag_left: "Primera visita + diagnòstic",
      tag_left_strong: "GRATIS",
      scroll: "Llisca",
    },
    philosophy: {
      eyebrow: "Filosofia",
      quote:
        "La salut bucodental dels nostres pacients és el nostre major èxit. Cada somriure és un projecte únic — concebut amb tècnica, paciència i bellesa.",
      sign: "— Dr. Iñaki Mayo",
      body:
        "Combinem ortodòncia digital, implantologia avançada i disseny del somriure en un entorn serè, pensat perquè tornis a gaudir sense esforç.",
    },
    stats: {
      a_num: "+20",
      a_label: "Anys d'experiència",
      b_num: "+8.000",
      b_label: "Pacients atesos",
      c_num: "+2.500",
      c_label: "Casos d'Invisalign",
      d_num: "100%",
      d_label: "Plans personalitzats",
    },
    treatments: {
      eyebrow: "Tractaments destacats",
      title: "Una atenció que s'adapta a tu.",
      cta_all: "Veure tots els tractaments",
      learn_more: "Saber més",
      benefits: "Beneficis",
      duration: "Durada estimada",
      sessions: "Visites estimades",
      cta_book: "Reservar consulta",
      cta_info: "Més informació",
    },
    doctor: {
      eyebrow: "Direcció clínica",
      name: "Dr. Iñaki Mayo",
      title: "Torna a somriure cada dia, torna a ser tu.",
      bio_1:
        "Especialista en implantologia i rehabilitació oral amb més de dues dècades de pràctica clínica. Combina formació internacional amb un enfocament artístic de l'odontologia.",
      bio_2:
        "La seva filosofia: tractar cada pacient com una peça única, amb temps, precisió i honestedat.",
      sign: "Iñaki Mayo",
      cta_team: "Coneix l'equip",
    },
    testimonials: {
      eyebrow: "Testimonis",
      title: "L'experiència dels qui ja somriuen amb nosaltres.",
      items: [
        { quote: "Han retornat al meu somriure el que jo creia perdut. El tracte i la professionalitat són excepcionals.", name: "Marta R.", city: "Cerdanyola" },
        { quote: "Després del meu Invisalign no reconec qui era abans. L'atenció de tot l'equip és exquisida.", name: "Joan S.", city: "Sabadell" },
        { quote: "Un espai que no sembla una clínica. Et cuiden com si fossis part d'una família.", name: "Laura P.", city: "Ripollet" },
      ],
    },
    faq: {
      eyebrow: "Preguntes freqüents",
      title: "Tot el que necessites saber.",
      items: [
        { q: "Quant costa la primera visita?", a: "La primera visita i el diagnòstic són completament gratuïts. Inclou exploració, les radiografies necessàries i un pla de tractament personalitzat." },
        { q: "Treballeu amb finançament?", a: "Sí. Disposem de finançament a mida, sense interessos fins a 12 mesos i opcions flexibles fins a 60 mesos." },
        { q: "Atengueu nens?", a: "Disposem d'un programa exclusiu Mayo Kids amb odontopediatres especialitzats i un entorn pensat per als més petits." },
        { q: "Quant dura el tractament d'Invisalign?", a: "Depèn de la complexitat. Sol oscil·lar entre 6 i 18 mesos, amb revisions cada 6–8 setmanes." },
        { q: "Com demano cita?", a: "Pots contactar-nos per WhatsApp al 621 078 618, per telèfon al 934 090 407 o el formulari. Responem en menys de 24 hores laborables." },
      ],
    },
    contact: {
      eyebrow: "Contacte",
      title: "Parlem del teu somriure.",
      lede: "Som a un missatge de distància. Resolem els teus dubtes, valorem el teu cas i et proposem un pla a la teva mida.",
      whatsapp: "Escriu-nos per WhatsApp",
      call: "Trucar a la clínica",
      address_label: "Adreça",
      address: "Av. Catalunya, 24\n08290 Cerdanyola del Vallès\nBarcelona",
      hours_label: "Horari",
      hours: "Dl–Dv: 9:00 – 20:30\nDissabte: 10:00 – 14:00",
      email_label: "Email",
      form_title: "Envia'ns un missatge",
      f_name: "Nom i cognoms",
      f_phone: "Telèfon",
      f_email: "Email",
      f_message: "Explica'ns breument el teu cas",
      f_treatment: "Tractament d'interès (opcional)",
      f_consent: "He llegit i accepto la política de privacitat",
      f_submit: "Enviar missatge",
      f_success: "Missatge enviat. Et contactarem en menys de 24h.",
      f_error: "No hem pogut enviar el teu missatge. Torna-ho a provar.",
      f_required: "Si us plau, completa els camps obligatoris.",
    },
    treatments_page: {
      eyebrow: "Catàleg de tractaments",
      title: "Tractaments d'avantguarda,\ndissenyats per a tu.",
      lede: "Una odontologia que uneix tecnologia avançada amb una visió artesanal del detall.",
      jump: "Anar al tractament",
    },
    promotions_page: {
      eyebrow: "Promocions",
      title: "També cuidem la teva butxaca.",
      lede:
        "Selecció de promocions actives. Subjectes a disponibilitat i estudi personalitzat previ.",
      terms: "Promocions no acumulables entre si. Subjectes a estudi previ i disponibilitat d'agenda.",
    },
    blog_page: {
      eyebrow: "Mayo Magazine",
      title: "Converses sobre el teu somriure.",
      lede: "Articles breus de l'equip clínic — per entendre millor cada tractament.",
      read_more: "Llegir article",
    },
    jobs_page: {
      eyebrow: "Treballa amb nosaltres",
      title: "Busquem professionals\namb vocació.",
      lede:
        "Si vols unir-te a un equip que entén l'odontologia com una professió artística i humana, aquest és el teu lloc. Envia'ns la teva candidatura.",
      f_position: "Lloc d'interès",
      f_experience: "Anys d'experiència",
      f_message: "Carta de presentació",
      f_submit: "Enviar candidatura",
      f_success: "Candidatura rebuda. Et contactarem aviat.",
      values_title: "El que ens mou",
      values: [
        { t: "Excel·lència clínica", d: "Formació contínua i protocols al màxim nivell internacional." },
        { t: "Tracte humà", d: "Cada pacient és una persona, no un cas clínic." },
        { t: "Tecnologia", d: "Treballem amb els millors equips digitals del sector." },
        { t: "Equip", d: "Creixem junts. La clínica és el que el seu equip construeix cada dia." },
      ],
    },
    footer: {
      tag: "Primera visita + diagnòstic GRATIS",
      cta: "Demana la teva cita",
      legal: "Avís legal",
      privacy: "Política de privacitat",
      cookies: "Política de cookies",
      rights: "© 2026 Iñaki Mayo Dental. Tots els drets reservats.",
      made: "Odontologia boutique a Cerdanyola del Vallès.",
      sections: { clinic: "Clínica", treatments: "Tractaments", contact: "Contacte", explore: "Explora" },
      follow: "Segueix-nos",
    },
  },
};
